import useScript from 'react-script-hook';
import {useLibraryState} from './ondemandLibrary';

/**
 * Hooks for loading recaptcha library only when needed.
 *
 * @returns {loaded: boolean}
 */
export const useRecaptcha = () => {
	const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_KEY;
	const {recaptchaLoaded, setRecaptchaLoaded, isProdLike} = useLibraryState();

	// see https://github.com/hupe1980/react-script-hook#readme
	useScript({
		src:
			isProdLike && !recaptchaLoaded
				? `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`
				: null, // never loaded if not prod
		checkForExisting: true,
		onload: () =>
			(window as any).grecaptcha.ready(() => {
				setRecaptchaLoaded(true);
			})
	});

	return {
		recaptchaLoaded
	};
};

/**
 * Retrieve a recaptcha token, for the input action.
 *
 * @param action a string value that may be signup or login
 * @returns null | recaptcha token id.
 */
export const getCaptchaToken = async (action: 'signup' | 'login') =>
	(window as any).grecaptcha?.execute(process.env.NEXT_PUBLIC_RECAPTCHA_KEY, {
		action
	});
